/** ACTIVE covers both "waiting for its start time" and "sending" */
export enum WhatsappCampaignStatus {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  COMPLETED = "COMPLETED",
  /** Kept for its history: nothing can be done to it any more */
  DELETED = "DELETED",
}
